'use strict';

/* globals define, config */

define('gameCreator', [
	config.relative_path + '/plugins/nodebb-plugin-memory-game/static/vendor/vue.js',
], function (Vue) {
	var GameCreator = {};

	GameCreator.init = function (game, translations) {
		new Vue({
			el: '#game-creator',
			data: {
				initData: {
					game: game,
					translations: translations,
				},
			},
		});
	};

	return GameCreator;
});
